import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { NotificationService } from '../_services';
import * as NotificationActions from '../_actions/notification';

@Injectable({
  providedIn: 'root',
})
export class NotificationEffects {
  loadNotifications$ = createEffect(() =>
    this.actions$.pipe(
      ofType(NotificationActions.loadNotifications),
      mergeMap(() =>
        this.notificationService.getNotifications().pipe(
          map((notifications) => NotificationActions.loadNotificationsSuccess({ notifications })),
          catchError((error) => of(NotificationActions.loadNotificationsFailure({ error })))
        )
      )
    )
  );

  addNotification$ = createEffect(() =>
    this.actions$.pipe(
      ofType(NotificationActions.addNotification),
      mergeMap(({ notification }) =>
        this.notificationService.saveNotification(notification).pipe(
          map((savedNotification) =>
            NotificationActions.addNotificationSuccess({ notification: savedNotification })
          ),
          catchError((error) => of(NotificationActions.addNotificationFailure({ error })))
        )
      )
    )
  );

  updateNotification$ = createEffect(() =>
    this.actions$.pipe(
      ofType(NotificationActions.updateNotification),
      mergeMap(({ notification }) =>
        this.notificationService.saveNotification(notification).pipe(
          map((updatedNotification) =>
            NotificationActions.updateNotificationSuccess({ notification: updatedNotification })
          ),
          catchError((error) => of(NotificationActions.updateNotificationFailure({ error })))
        )
      )
    )
  );

  deleteNotification$ = createEffect(() =>
    this.actions$.pipe(
      ofType(NotificationActions.deleteNotification),
      mergeMap(({ id }) =>
        this.notificationService.deleteNotification(id).pipe(
          map(() => NotificationActions.deleteNotificationSuccess({ id })),
          catchError((error) => of(NotificationActions.deleteNotificationFailure({ error })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private notificationService: NotificationService
  ) {}
}
